import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Select, MenuItem, InputLabel } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import moment from 'moment'
import 'moment/locale/pt-br'

import styles from './styles.module.scss'
import Paginacao from '../../../components/Paginacao'
import {
    getParceiros,
    getFilial,
    adminstradorAtivarInativar,
    perfisParticipantes,
    perfisAcessoParticipantes,
    enderecoEstados,
    enderecoCidades,
    enderecoEndByCep,
    postCadastrarResponsavel,
    getResponsavelById,
    getParceirosByResponsavelId,
    getParceirosByParticipantesId,
    getRegional
} from '../../../services/api-auto';
import ParceiroCard from '../../../components/ParceiroCard';

import { useDispatch } from "react-redux"
import {
    showMsgW as showMsgWAction,
    showMsgE as showMsgEAction,
    showMsgS as showMsgSAction,
} from '../../../store/actions/snackbarActions.js';
import { useDebounce } from '../../../hooks/debounceHook'
import ModalLoading from '../../../components/ModalLoading'
import service from '../../../services'
import { useGetUser } from '../../../hooks/useGetUser';
import PasswordStrength from '../../../components/PasswordStrength'
import Voltar from '../../../components/VoltarBtn/voltar'
import AcoesUser from '../../../components/ButtonsAcoes'
import services from '../../../services'

const dataInit = {
    userId: "",
    nomeCompleto: "",
    cpf: "",
    dataNascimento: null,
    email: "",
    phoneNumber: "",
    cargo: "",
    cep: "",
    uf1: 0,
    cidade1: 0,
    bairro: "",
    logradouro: "",
    numero: "",
    complemento: "",
    usarEnderecoEntrega: true,
    cep2: "",
    uf2: 0,
    cidade2: 0,
    bairro2: "",
    logradouro2: "",
    numero2: "",
    complemento2: "",
    senha: "",
    confirmaSenha: "",
    perfilAcesso: "",
    perfilAcessoId: "",
    addResponsavelPdvs: [],
    removerResponsavelPdvs: [],
    status: ""
}

const claimName = "Responsaveis"

const cargoInit = {
    roleId: '',
    displayName: ''
}

const Detalhes = () => {
    const dispatch = useDispatch();
    const showMsgW = (msg) => dispatch(showMsgWAction(msg));
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));
    const showMsgS = (msg) => dispatch(showMsgSAction(msg));

    const [buscar, setBuscar] = useState('');
    const [data, setData] = useState(dataInit);
    const [regional, setRegional] = useState([]);

    const user = useGetUser();

    const [regionalSelecionado, setRegionalSelecionado] = useState('todos');
    const [filial, setFilial] = useState([]);
    const [filialSelecionado, setFilialSelecionado] = useState('todos');
    const [parceiros, setParceiros] = useState([]);
    const [parceiroSelecionado, setParceiroSelecionado] = useState('todos');
    const [perfisList, setPerfisList] = useState([]);
    const [perfisAcessoList, setPerfisAcessoList] = useState([]);

    const history = useHistory()

    const [estados, setEstados] = useState([])
    const [cidades1, setCidades1] = useState([])
    const [cidades2, setCidades2] = useState([])

    const [nomeParceiroSelecionado, setNomeParceiroSelecionado] = useState('todos');
    const [codigoParceiroSelecionado, setCodigoParceiroSelecionado] = useState('todos');
    const [parceiroAcaoPresentes, setParceiroAcaoPresentes] = useState([])
    const [indicarErros, setIndicarErros] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);

    const [cep1, setCep1] = useState("")
    const [cep2, setCep2] = useState("")
    const [permiteAdicionarAlterarResponsavel, setPermiteAdicionarAlterarResponsavel] = useState(false);

    useDebounce(cep1, 750, () => { validarCep1() });
    useDebounce(cep2, 750, () => { validarCep2() });

    const validarCep1 = async () => {
        const info = await enderecoEndByCep(cep1)
        let arr = {}
        if (info.data.bairro) { arr.bairro = info.data.bairro }
        if (info.data.logradouro) { arr.logradouro = info.data.logradouro }
        if (info.data.uf) { arr.uf = info.data.uf.ufId }
        if (info.data.cidade) { arr.cidade1 = info.data.cidade.cidadeId }

        setData({ ...data, ...arr })
    }

    const validarCep2 = async () => {
        const info = await enderecoEndByCep(cep2)
        let arr = {}
        if (info.data.bairro) { arr.bairro2 = info.data.bairro }
        if (info.data.logradouro) { arr.logradouro2 = info.data.logradouro }
        if (info.data.uf) { arr.uf2 = info.data.uf.ufId }
        if (info.data.cidade) { arr.cidade2 = info.data.cidade.cidadeId }

        setData({ ...data, ...arr })
    }

    const validarForm = () => {
        let valid = true
        let msg = ""

        if (!data.nomeCompleto) {
            let msg = `Campo nome obrigatório`;
            valid = false;
            showMsgW(msg)
        }
        if (!data.cpf) {
            msg = "Campo CPF é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }

        if (!new moment(data.dataNascimento).isValid() && data.dataNascimento) { 
            msg = 'Campo Data de Nascimento inválido';
            valid = false;
            showMsgW(msg)
        }

        if (!data.email) {
            msg = "Campo E-mail é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }
        if (!data.phoneNumber) {
            msg = "Campo Celular é obrigatório\n";
            valid = false;
            showMsgW(msg)
        } else if (!service.validate.valideCellphone(service.mask.unMask(data.phoneNumber))) {
            msg = "Campo Celular inválido\n";
            valid = false;
            showMsgW(msg)
        }

        if (!(data.nomeCompleto.trim().split(' ').length > 1)) {
            let msg = `Campo nome inválido`;
            valid = false;
            showMsgW(msg)
        }        
        if (!data.cargo) {
            msg = "Campo cargo é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }
        // if( data.perfilAcesso == null ){
        //     msg = "Campo perfil é obrigatório\n"; 
        //     valid = false; 
        //     showMsgW(msg)
        // }

        /* endereço 
        if (data.cep == null) {
            msg = "Campo Cep é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }

        if (data.cidade1 == null) {
            msg = "Campo Cidade é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }

        if (data.bairro == null) {
            msg = "Campo Bairro é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }

        if (data.logradouro == null) {
            msg = "Campo Logradouro é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }

        if (data.numero == null || data.numero == "") {
            msg = "Campo Número é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }
*/
        /* endereço

        if (data.cep2 == null && !data.usarEnderecoEntrega) {
            msg = "Campo Cep entrega é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }

        if (data.cidade2 == null && !data.usarEnderecoEntrega) {
            msg = "Campo Cidade entrega é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }

        if (data.bairro2 == null && !data.usarEnderecoEntrega) {
            msg = "Campo Bairro entrega é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }

        if (data.logradouro2 == null && !data.usarEnderecoEntrega) {
            msg = "Campo Logradouro entrega é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }

        if (data.numero2 == null && !data.usarEnderecoEntrega) {
            msg = "Campo Número entrega é obrigatório\n";
            valid = false;
            showMsgW(msg)
        }
 2*/
        if (!data.userId && !data.senha) {
            msg = "Campo Senha é obrigatórios para cadastro de novo usuário\n";
            valid = false;
            showMsgW(msg)
        }

        if (data.senha && !data.confirmaSenha) {
            msg = "Campo Confirmar Senha é obrigatórios\n";
            valid = false;
            showMsgW(msg)
        }

        if (data.senha && data.senha !== data.confirmaSenha) {
            msg = "Campo Confirmar Senha deve ser igual campo Senha\n";
            valid = false;
            showMsgW(msg)
        }

        if (data.senha && (!service.validate.validePasswordSize(data.senha) ||
            !service.validate.validePasswordNumber(data.senha) ||
            !service.validate.validePasswordCapital(data.senha) ||
            !service.validate.validePasswordSpecial(data.senha))) {
            msg = "Campo Senha não cumpre todos os requerimentos\n";
            valid = false;
            showMsgW(msg)
        }

        return valid
    }

    const encerrar = async () => {

        setModalLoading(true)
        const newStatus = status === 'Ativo' ? 'ativar' : 'inativar'
        await adminstradorAtivarInativar(data.userId, newStatus)
        setModalLoading(false)
        history.push('/responsaveis')
    }

    const getCampanhaIfEdit = async (id) => {
        
        if (id) {
            setModalLoading(true)
            try {
                let info = await getResponsavelById(id);
                info = info.data.usuario
                setData({
                    ...data,
                    userId: info.userId,
                    nomeCompleto: info.nome,
                    cpf: info.userName,
                    dataNascimento: info.dataNascimento,
                    email: info.email,
                    phoneNumber: info.phoneNumber,
                    cargo: info.role === null ? "" : info.role.displayName,
                    cidade1: info.cidade1,
                    uf1: info.uf1,
                    bairro: info.bairro1 === "string" ? "" : info.bairro1,
                    logradouro: info.logradouro1 === "string" ? "" : info.logradouro1,
                    numero: info.numero1 === "string" ? "" : info.numero1,
                    complemento: info.complemento1 === "string" ? "" : info.complemento1,
                    cidade2: info.cidade2,
                    uf2: info.uf2,
                    bairro2: info.bairro2 === "string" ? "" : info.bairro2,
                    logradouro2: info.logradouro2 === "string" ? "" : info.logradouro2,
                    numero2: info.numero2 === "string" ? "" : info.numero2,
                    complemento2: info.complemento2 === "string" ? "" : info.complemento2,
                    usarEnderecoEntrega: info.mesmoEnderecoEntrega,
                    perfilAcesso: info.perfilAcesso,
                    perfilAcessoId: info.perfilAcessoId
                });

                setCep1(info.cep1)
                setCep2(info.cep2)

                pesquisar(info);
            } catch (err) {
                showMsgW('Não foi possível carregar os dados')
            }
            setModalLoading(false)
        }
    }

    // controle da lista de lojas novas
    function adicionarParceiroNovo() {
        var i = data.addResponsavelPdvs.findIndex(a => a.idParceiro === parceiroSelecionado);

        if (i === -1) {
            var novoData = {
                ...data,
                addResponsavelPdvs: [
                    ...data.addResponsavelPdvs,
                    {
                        "regional": regionalSelecionado,
                        "filial": filialSelecionado,
                        "nomeParceiro": nomeParceiroSelecionado,
                        "idParceiro": parceiroSelecionado,
                        "codigo": codigoParceiroSelecionado
                    }
                ]
            };

            setData(novoData);
         
        }
    }

    function removerParceiroNovo(parceiro, i) {
        var novoData = { ...data };
        novoData.addResponsavelPdvs.splice(i, 1);

        setData(novoData);
    }

    // controle da lista de lojas cadastradas
    function removerParceiroExistente(parceiro, i) {
        var novoData = {
            ...data,
            removerResponsavelPdvs: [
                ...data.removerResponsavelPdvs,
                parceiro
            ]
        };

        setData(novoData);

        var novoParceiroAcaoPresentes = [...parceiroAcaoPresentes];
        novoParceiroAcaoPresentes.splice(i, 1);
        setParceiroAcaoPresentes(novoParceiroAcaoPresentes);
    }

    // controle da lista de lojas cadastradas a remover
    function voltarParceiroExistente(parceiro, i) {
        var novoData = { ...data };
        novoData.removerResponsavelPdvs.splice(i, 1);
        setData(novoData);

        var novoParceiroAcaoPresentes = [...parceiroAcaoPresentes, parceiro];
        setParceiroAcaoPresentes(novoParceiroAcaoPresentes);
    }

    const carregarRegional = async () => {
        const info = await getRegional()
        setRegional(info);
    }

    const carregarFilial = async () => {
        const info = await getFilial(regionalSelecionado)
        setFilial(info);
    }

    const carregarParceiro = async () => {
        const info = await getParceiros(regionalSelecionado, filialSelecionado)
        setParceiros(info);
    }

    const carregarEstados = async () => {
        const info = await enderecoEstados();
        setEstados(info.data)
    }

    const carregarCidades1 = async () => {
        if (Boolean(data.uf)) {
            const info = await enderecoCidades(data.uf.ufId ?? data.uf);
            setCidades1(info.data)
        }
    }
    useEffect(() => { carregarCidades1() }, [data.uf])

    const carregarCidades2 = async () => {
        ;
        if (Boolean(data.uf2)) {
            const info = await enderecoCidades(data.uf2?.ufId ?? data.uf2);
            setCidades2(info.data)
        }
    }
    useEffect(() => { carregarCidades2() }, [data.uf2])
    const status = new URLSearchParams(history.location.search).get("status")
    const createSenderForm = () => {
        let formdata = {};
        if (data.userId !== '') { formdata.userId = data.userId; }
        formdata.nomeCompleto = data.nomeCompleto;
        formdata.cpf = service.mask.unMask(data.cpf);
        formdata.dataNascimento = data.dataNascimento;
        formdata.email = data.email;
        formdata.phoneNumber = service.mask.unMask(data.phoneNumber);
        formdata.cargo = data.cargo;
        formdata.cep = service.mask.unMask(cep1);
        formdata.cidade1 = { cidadeId: data.cidade1?.cidadeId || data.cidade1 };
        formdata.bairro = data.bairro;
        formdata.logradouro = data.logradouro;
        formdata.numero = data.numero;
        formdata.complemento = data.complemento;
        formdata.usarEnderecoEntrega = data.usarEnderecoEntrega;
        formdata.perfilAcesso = data.perfilAcesso;
        formdata.perfilAcessoId = data.perfilAcessoId;
        if (!data.usarEnderecoEntrega) {
            formdata.cep2 = service.mask.unMask(cep2);
            formdata.cidade2 = { cidadeId: data.cidade2?.cidadeId || data.cidade2 };
            formdata.bairro2 = data.bairro2;
            formdata.logradouro2 = data.logradouro2;
            formdata.numero2 = data.numero2;
            formdata.complemento2 = data.complemento2;
        }
        formdata.senha = data.senha;
        formdata.confirmaSenha = data.confirmaSenha;
        formdata.addResponsavelPdvs = data.addResponsavelPdvs;
        formdata.removerResponsavelPdvs = data.removerResponsavelPdvs;

        for (let i = 0; i < data.addResponsavelPdvs.length; i++) {
            formdata[`addResponsavelPdvs[${i}].idParceiro`] = data.addResponsavelPdvs[i].idParceiro;
            formdata[`addResponsavelPdvs[${i}].regional`] = data.addResponsavelPdvs[i].regional;
            formdata[`addResponsavelPdvs[${i}].filial`] = data.addResponsavelPdvs[i].filial;
            formdata[`addResponsavelPdvs[${i}].nomeParceiro`] = data.addResponsavelPdvs[i].nomeParceiro;
            formdata[`addResponsavelPdvs[${i}].codigoParceiro`] = data.addResponsavelPdvs[i].codigoParceiro;
        }
        for (let i = 0; i < data.removerResponsavelPdvs.length; i++) {
            formdata[`removerResponsavelPdvs[${i}].idParceiro`] = data.removerResponsavelPdvs[i].idParceiro;
            formdata[`removerResponsavelPdvs[${i}].regional`] = data.removerResponsavelPdvs[i].regional;
            formdata[`removerResponsavelPdvs[${i}].filial`] = data.removerResponsavelPdvs[i].filial;
            formdata[`removerResponsavelPdvs[${i}].nomeParceiro`] = data.removerResponsavelPdvs[i].nomeParceiro;
            formdata[`removerResponsavelPdvs[${i}].codigoParceiro`] = data.removerResponsavelPdvs[i].codigoParceiro;
        }

        return formdata;
    }

    const enviar = async () => {
        setIndicarErros(false)
        if (validarForm()) {
            let formdata = createSenderForm()
            setModalLoading(true)
            try {
                let info = await postCadastrarResponsavel(formdata);
                if (info.statusCode !== 200) { throw new Error("Error"); }
                showMsgS("Dados salvos com sucesso!")
                setTimeout(() => {
                    history.push('/responsaveis')
                }, 2000)
            } catch (e) {
                showMsgE(e.response.data)
            }
          
            setModalLoading(false)

        }
    }

    const pesquisar = async function (data) {
        var response = await getParceirosByResponsavelId(data.userId, buscar, page)
        if (response.items.length == 0)
            response = await getParceirosByParticipantesId(data.userId, buscar, page);

        setParceiroAcaoPresentes(response.items);
        setMaxPage(response.totalPages)
    }

    const loadPerfil = async () => {
        const info = await perfisParticipantes()
        setPerfisList(info.data)
    }

    const loadPerfilAcesso = async () => {
        const info = await perfisAcessoParticipantes()
        setPerfisAcessoList(info.data)
    }

    const handlerPerfil = (e) => {
        setData({ ...data, perfilAcessoId: e.target.value })
    }

    useEffect(() => {
        const adm = new URLSearchParams(history.location.search).get("usuario")
        getCampanhaIfEdit(adm)
        carregarEstados()
        loadPerfil()
        loadPerfilAcesso()
        carregarRegional()
    }, [])

    useEffect(() => {
        const alteraResponsavel = services.storage.getClaimValues(claimName, "Alterar");
        const adicionarResponsavel = services.storage.getClaimValues(claimName, "Cadastrar");
        var adicionaAltera = false;

        const acao = new URLSearchParams(history.location.search).get("acao")

        if ((adicionarResponsavel && acao === 'I') || (alteraResponsavel && acao === 'A'))
            adicionaAltera = true;

        setPermiteAdicionarAlterarResponsavel(adicionaAltera);

    }, [permiteAdicionarAlterarResponsavel])


    useEffect(() => {
        if (regionalSelecionado) {
            carregarFilial();
        }
    }, [regionalSelecionado])

    useEffect(() => {
        if (filialSelecionado) {
            carregarParceiro();
        }
    }, [filialSelecionado])

    useEffect(() => {
        if (data.userId) {
            pesquisar(data)
        }
    }, [page])

    return (
        <>
            <div className={styles.wrapper}>
                <div className={styles.title}>
                    Participante
                    <Voltar />
                </div>
                <div className={styles.blueBackground}>
                    <div className={styles.content}>
                        <div className={styles.card}>
                            <div className={styles.subtitle}>
                                Dados pessoais
                            </div>
                            <FormControl className={styles.half}>
                                <TextField type="text" size="small"
                                    onChange={(e) => { setData({ ...data, nomeCompleto: e.target.value }) }}
                                    label="Nome completo"
                                    inputVariant="outlined"
                                    value={data.nomeCompleto}
                                    variant="filled"
                                    className="customFilledInput"
                                    disabled={!permiteAdicionarAlterarResponsavel}
                                />
                            </FormControl>
                            <FormControl className={styles.quarter}>
                                <TextField type="text" size="small"
                                    onChange={(e) => { setData({ ...data, cpf: e.target.value }) }}
                                    label="CPF"
                                    value={service.mask.cpf(data.cpf)}
                                    variant="filled"
                                    error={indicarErros && !data.cpf ? true : false}
                                    className="customFilledInput"
                                    disabled={data.userId}
                                />
                            </FormControl>
                            <FormControl className={`${styles.quarter}`}>
                                <MuiPickersUtilsProvider locale="pt-br" libInstance={moment} utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        autoOk
                                        variant="inline"
                                        inputVariant="outlined"
                                        label="Data de Nascimento"
                                        format="DD/MM/yyyy"
                                        value={data.dataNascimento}
                                        InputAdornmentProps={{ position: "start" }}
                                        onChange={novaData => { setData({ ...data, dataNascimento: novaData }) }}
                                        className="customFilledInput"
                                        error={indicarErros && !data.dataNascimento ? true : false}
                                        invalidDateMessage="Data em formato inválido."
                                        maxDateMessage="Data não deve ser maior que a data máxima."
                                        minDateMessage="Data não deve ser menor que a data mínima."
                                    />
                                </MuiPickersUtilsProvider>
                            </FormControl>
                            <FormControl className={styles.quarter}>
                                <TextField type="text" size="small"
                                    onChange={(e) => { setData({ ...data, email: e.target.value }) }}
                                    label="E-mail"
                                    value={data.email}
                                    variant="filled"
                                    error={indicarErros && !data.email ? true : false}
                                    className="customFilledInput"
                                    disabled={!permiteAdicionarAlterarResponsavel}
                                />
                            </FormControl>
                            <FormControl className={styles.quarter}>
                                <TextField type="text"
                                    onChange={(e) => { setData({ ...data, phoneNumber: service.mask.celphone(e.target.value) }) }}
                                    label="Celular"
                                    value={service.mask.celphone(data.phoneNumber)}
                                    variant="filled"
                                    error={indicarErros && !data.phoneNumber ? true : false}
                                    className="customFilledInput"
                                    disabled={!permiteAdicionarAlterarResponsavel}
                                />
                            </FormControl>
                            <FormControl className={styles.quarter}>
                                <InputLabel id="select-tipo-label" className={styles.label}>
                                    Cargo
                                </InputLabel>
                                <Select
                                    labelId='select-tipo-label'
                                    label="Cargo"
                                    onChange={(e) => { setData({ ...data, cargo: e.target.value }) }}
                                    value={data.cargo}
                                    variant='filled'
                                    className="customFilledInput"
                                    disabled={!permiteAdicionarAlterarResponsavel}
                                >
                                    {
                                        perfisList.map((item) => {
                                            return (
                                                <MenuItem value={item.displayName} key={item.roleId}>
                                                    {item.displayName}
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <FormControl className={styles.quarter}>
                                <InputLabel id="select-tipo-label" className={styles.label}>
                                    Perfil de Acesso
                                </InputLabel>
                                <Select
                                    labelId='select-tipo-label'
                                    label="Perfil de Acesso"
                                    onChange={(e) => handlerPerfil(e)}
                                    value={data.perfilAcessoId}
                                    variant='filled'
                                    className="customFilledInput"
                                    disabled={!permiteAdicionarAlterarResponsavel}
                                >
                                    {
                                        perfisAcessoList.map((item) => {
                                            return (
                                                <MenuItem value={item.id} key={item.id}>
                                                    {item.apelido}
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <div className={styles.subtitle}>
                                Endereço
                            </div>
                            <FormControl className={styles.quarter}>
                                <TextField type="text" size="small"
                                    onChange={(e) => { setCep1(service.mask.cep(e.target.value)) }}
                                    label="Cep"
                                    value={service.mask.cep(cep1)}
                                    variant="filled"
                                    error={indicarErros && !cep1 ? true : false}
                                    className="customFilledInput"
                                    disabled={!permiteAdicionarAlterarResponsavel}
                                />
                            </FormControl>
                            <FormControl className={styles.quarter}>
                                <TextField type="text" size="small"
                                    onChange={(e) => { setData({ ...data, logradouro: e.target.value }) }}
                                    label="Logradouro"
                                    value={data.logradouro}
                                    variant="filled"
                                    error={indicarErros && !data.logradouro ? true : false}
                                    className="customFilledInput"
                                    disabled={!permiteAdicionarAlterarResponsavel}
                                />
                            </FormControl>
                            <FormControl className={styles.quarter}>
                                <TextField type="text" size="small"
                                    onChange={(e) => { setData({ ...data, numero: e.target.value }) }}
                                    label="Número"
                                    value={data.numero}
                                    variant="filled"
                                    error={indicarErros && !data.numero ? true : false}
                                    className="customFilledInput"
                                    disabled={!permiteAdicionarAlterarResponsavel}
                                />
                            </FormControl>
                            <FormControl className={styles.quarter}>
                                <TextField type="text" size="small"
                                    onChange={(e) => { setData({ ...data, complemento: e.target.value }) }}
                                    label="Complemento"
                                    value={data.complemento}
                                    variant="filled"
                                    error={indicarErros && !data.complemento ? true : false}
                                    className="customFilledInput"
                                    disabled={!permiteAdicionarAlterarResponsavel}
                                />
                            </FormControl>
                            <FormControl className={styles.quarter}>
                                <TextField type="text"
                                    onChange={(e) => { setData({ ...data, bairro: e.target.value }) }}
                                    label="Bairro"
                                    value={data.bairro}
                                    variant="filled"
                                    error={indicarErros && !data.bairro ? true : false}
                                    className="customFilledInput"
                                    disabled={!permiteAdicionarAlterarResponsavel}
                                />
                            </FormControl>
                            <FormControl className={styles.quarter}>
                                <InputLabel id="select-tipo-label" className={styles.label}>
                                    UF
                                </InputLabel>
                                <Select
                                    labelId='select-tipo-label'
                                    label="UF"
                                    onChange={(e) => { setData({ ...data, uf1: e.target.value }) }}
                                    value={data.uf1}
                                    variant='filled'
                                    className="customFilledInput"
                                    disabled={!permiteAdicionarAlterarResponsavel}
                                >
                                    {
                                        estados.map((item) => {
                                            return (
                                                <MenuItem value={item.ufId} key={item.ufId}>
                                                    {item.sigla}
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <FormControl className={styles.quarter}>
                                <InputLabel id="select-tipo-label" className={styles.label}>
                                    Município
                                </InputLabel>
                                <Select
                                    labelId='select-tipo-label'
                                    label="Município"
                                    onChange={(e) => { setData({ ...data, cidade1: e.target.value }) }}
                                    value={data.cidade1}
                                    variant='filled'
                                    className="customFilledInput"
                                    disabled={!permiteAdicionarAlterarResponsavel}
                                >
                                    {
                                        cidades1.map((item) => {
                                            return (
                                                <MenuItem value={item.cidadeId} key={item.cidadeId}>
                                                    {item.nome}
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <div>
                                Deseja usar o mesmo endereço para entrega?
                                <div className={styles.wrapperUsarEnderecoEntrega}>
                                    <FormControlLabel value={data.usarEnderecoEntrega} control={
                                        <Checkbox style={{ color: '#5CCBE1' }}
                                            checked={data.usarEnderecoEntrega}
                                            onChange={e => { setData({ ...data, usarEnderecoEntrega: true }) }}
                                            disabled={!permiteAdicionarAlterarResponsavel}
                                        />
                                    } label="Sim" className={styles.radioOptions} />
                                    <FormControlLabel value={!data.usarEnderecoEntrega} control={
                                        <Checkbox style={{ color: '#5CCBE1' }}
                                            checked={!data.usarEnderecoEntrega}
                                            onChange={e => { setData({ ...data, usarEnderecoEntrega: false }) }}
                                            disabled={!permiteAdicionarAlterarResponsavel}
                                        />
                                    } label="Não" className={styles.radioOptions} />
                                </div>
                            </div>
                            {(!data.usarEnderecoEntrega) && (<>
                                <div className={styles.subtitle}>
                                    Endereço de entrega
                                </div>
                                <FormControl className={styles.quarter}>
                                    <TextField type="text" size="small"
                                        onChange={(e) => { setCep2(service.mask.cep(e.target.value)) }}
                                        label="Cep entrega"
                                        value={service.mask.cep(cep2)}
                                        variant="filled"
                                        error={indicarErros && !cep2 ? true : false}
                                        className="customFilledInput"
                                        disabled={!permiteAdicionarAlterarResponsavel}
                                    />
                                </FormControl>
                                <FormControl className={styles.quarter}>
                                    <TextField type="text" size="small"
                                        onChange={(e) => { setData({ ...data, logradouro2: e.target.value }) }}
                                        label="Logradouro entrega"
                                        value={data.logradouro2}
                                        variant="filled"
                                        error={indicarErros && !data.logradouro2 ? true : false}
                                        className="customFilledInput"
                                        disabled={!permiteAdicionarAlterarResponsavel}
                                    />
                                </FormControl>
                                <FormControl className={styles.quarter}>
                                    <TextField type="text" size="small"
                                        onChange={(e) => { setData({ ...data, numero2: e.target.value }) }}
                                        label="Número entrega"
                                        value={data.numero2}
                                        variant="filled"
                                        error={indicarErros && !data.numero2 ? true : false}
                                        className="customFilledInput"
                                        disabled={!permiteAdicionarAlterarResponsavel}
                                    />
                                </FormControl>
                                <FormControl className={styles.quarter}>
                                    <TextField type="text" size="small"
                                        onChange={(e) => { setData({ ...data, complemento2: e.target.value }) }}
                                        label="Complemento entrega"
                                        value={data.complemento2}
                                        variant="filled"
                                        error={indicarErros && !data.complemento2 ? true : false}
                                        className="customFilledInput"
                                        disabled={!permiteAdicionarAlterarResponsavel}
                                    />
                                </FormControl>
                                <FormControl className={styles.quarter}>
                                    <TextField type="text" size="small"
                                        onChange={(e) => { setData({ ...data, bairro2: e.target.value }) }}
                                        label="Bairro entrega"
                                        value={data.bairro2}
                                        variant="filled"
                                        error={indicarErros && !data.bairro2 ? true : false}
                                        className="customFilledInput"
                                        disabled={!permiteAdicionarAlterarResponsavel}
                                    />
                                </FormControl>
                                <FormControl className={styles.quarter}>
                                    <InputLabel id="select-tipo-label" className={styles.label}>
                                        UF
                                    </InputLabel>
                                    <Select
                                        labelId='select-tipo-label'
                                        label="UF entrega"
                                        onChange={(e) => { setData({ ...data, uf2: e.target.value }) }}
                                        value={data.uf2}
                                        variant='filled'
                                        className="customFilledInput"
                                        disabled={!permiteAdicionarAlterarResponsavel}
                                    >
                                        {
                                            estados.map((item) => {
                                                return (
                                                    <MenuItem value={item.ufId} key={item.ufId}>
                                                        {item.sigla}
                                                    </MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                </FormControl>
                                <FormControl className={styles.quarter}>
                                    <InputLabel id="select-tipo-label" className={styles.label}>
                                        Município
                                    </InputLabel>
                                    <Select
                                        labelId='select-tipo-label'
                                        label="Município entrega"
                                        onChange={(e) => { setData({ ...data, cidade2: e.target.value }) }}
                                        value={data.cidade2}
                                        variant='filled'
                                        className="customFilledInput"
                                        disabled={!permiteAdicionarAlterarResponsavel}
                                    >
                                        {
                                            cidades2.map((item) => {
                                                return (
                                                    <MenuItem value={item.cidadeId} key={item.cidadeId}>
                                                        {item.nome}
                                                    </MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                </FormControl>
                            </>)}


                            <div className='col-sm-12'>
                                <FormControl  >
                                    <TextField label="Senha" type="password" size="small"
                                        onChange={event => { setData({ ...data, senha: event.target.value }) }}
                                        value={data.senha}
                                        variant="filled"
                                        className="customFilledInput"
                                    />
                                </FormControl>
                            </div>

                            <PasswordStrength password={data.senha} />

                            <div className='col-sm-12'>
                                <FormControl>
                                    <TextField label="Confirme sua senha" type="password" size="small"
                                        onChange={event => { setData({ ...data, confirmaSenha: event.target.value }) }}
                                        value={data.confirmaSenha}
                                        variant="filled"
                                        className="customFilledInput"
                                    />
                                </FormControl>
                            </div>

                        </div>
                    </div>
                </div>
                <div className={styles.blueBackground}>
                    <div className={styles.content}>
                        <div className={styles.card}>
                            <div className={styles.subtitle}>
                                Lojas
                            </div>
                            {
                                permiteAdicionarAlterarResponsavel && (
                                    <>
                                        <FormControl className={styles.selects} disabled={!permiteAdicionarAlterarResponsavel}>
                                            <InputLabel id="select-status-label" className={styles.selectsLabel}>
                                                Regional
                                            </InputLabel>
                                            <Select
                                                labelId='select-status-label'
                                                label="Status"
                                                onChange={(e) => { setRegionalSelecionado(e.target.value) }}
                                                value={regionalSelecionado}
                                                variant="filled"
                                                className="customFilledInput"
                                            >
                                                <MenuItem value="todos">Todos</MenuItem>
                                                {regional.map((regiao) => {
                                                    return (
                                                        <MenuItem value={regiao} key={regiao}>{regiao}</MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                        <FormControl className={styles.selects} disabled={!permiteAdicionarAlterarResponsavel}>
                                            <InputLabel id="select-status-label" className={styles.selectsLabel}>
                                                Filial
                                            </InputLabel>
                                            <Select
                                                labelId='select-status-label'
                                                label="Status"
                                                onChange={(e) => { setFilialSelecionado(e.target.value) }}
                                                value={filialSelecionado}
                                                variant="filled"
                                                className="customFilledInput"
                                            >
                                                <MenuItem value="todos">Todos</MenuItem>
                                                {filial.map((info) => {
                                                    return (
                                                        <MenuItem value={info} key={info}>{info}</MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                        <FormControl className={styles.selects} disabled={!permiteAdicionarAlterarResponsavel}>
                                            <InputLabel id="select-status-label" className={styles.selectsLabel}>
                                                Loja
                                            </InputLabel>
                                            <Select
                                                labelId='select-status-label'
                                                label="Status"
                                                onChange={(e) => {
                                                    if (e.target.value !== "todos") {
                                                        setParceiroSelecionado(e.target.value)
                                                        let parceiro = parceiros.find((p) => p.idParceiro === e.target.value)
                                                        setNomeParceiroSelecionado(parceiro.nomeParceiro)
                                                        setCodigoParceiroSelecionado(parceiro.codigo)
                                                    } else {
                                                        setParceiroSelecionado(e.target.value)
                                                        setNomeParceiroSelecionado(e.target.value)
                                                        setCodigoParceiroSelecionado(e.target.value)
                                                    }
                                                }}
                                                value={parceiroSelecionado}
                                                variant="filled"
                                                className="customFilledInput"
                                            >
                                                <MenuItem value="todos">Todos</MenuItem>
                                                {parceiros.map((parceiro) => {
                                                    return (
                                                        <MenuItem value={parceiro.idParceiro} key={parceiro.idParceiro}>
                                                            {parceiro.nomeParceiro}
                                                        </MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                        <button className={styles.salvar} onClick={adicionarParceiroNovo}>
                                            Adicionar
                                        </button>
                                        <div className={styles.subtitleConfiguracao}>
                                            Lojas - adicionar
                                        </div>
                                        <div className={styles.addLojasWrapper}>
                                            {
                                                Boolean(data.addResponsavelPdvs.length) ?
                                                    data.addResponsavelPdvs.map((loja, i) => {
                                                        return (
                                                            <ParceiroCard
                                                                parceiro={loja}
                                                                key={loja.idParceiro}
                                                                remover={() => removerParceiroNovo(loja, i)} />
                                                        )
                                                    }) :
                                                    (
                                                        <div>
                                                            Nenhum parceiro nesta lista
                                                        </div>
                                                    )
                                            }
                                        </div>
                                    </>
                                )
                            }
                            {
                                data.userId && (
                                    <>
                                        <div className={styles.subtitleConfiguracao}>
                                            Lojas - cadastradas
                                        </div>
                                        {
                                            Boolean(parceiroAcaoPresentes.length) ?
                                                <div className={styles.searchWrapper}>
                                                    <TextField
                                                        type="text"
                                                        size="small"
                                                        onChange={(e) => { setBuscar(e.target.value) }}
                                                        label="Faça sua busca"
                                                        value={buscar}
                                                        variant="filled"
                                                        multiline
                                                        className="customFilledInput"
                                                        onKeyDown={
                                                            (e) => {
                                                                if (e.key === 'Enter') {
                                                                    pesquisar(data.userId);
                                                                    e.preventDefault();
                                                                }
                                                            }
                                                        }
                                                        InputProps={{
                                                            endAdornment: (
                                                                <button onClick={() => pesquisar(data.userId)} className={styles.searchButton}>
                                                                    <FontAwesomeIcon icon={faSearch} />
                                                                </button>
                                                            )
                                                        }}
                                                    />
                                                </div>
                                                :
                                                ""
                                        }

                                        <div className={styles.addLojasWrapper}>
                                            {
                                                Boolean(parceiroAcaoPresentes.length) ?
                                                    parceiroAcaoPresentes.map((loja, i) => {
                                                        return (
                                                            <ParceiroCard
                                                                parceiro={loja}
                                                                key={loja.idParceiro}
                                                                permiteAdicionarAlterarResponsavel={permiteAdicionarAlterarResponsavel}
                                                                remover={() => removerParceiroExistente(loja, i)} />
                                                        )
                                                    }) :
                                                    (
                                                        <div>
                                                            Nenhum parceiro nesta lista
                                                        </div>
                                                    )
                                            }
                                        </div>
                                        {maxPage > 1 && (
                                            <Paginacao maxPage={maxPage} page={page} setPage={setPage} />
                                        )}
                                        {
                                            permiteAdicionarAlterarResponsavel && (
                                                <>
                                                    <div className={styles.subtitleConfiguracao}>
                                                        Lojas - remover
                                                    </div>
                                                    <div className={styles.addLojasWrapper}>
                                                        {
                                                            Boolean(data.removerResponsavelPdvs.length) ?
                                                                data?.removerResponsavelPdvs?.map((loja, i) => {
                                                                    return (
                                                                        <ParceiroCard parceiro={loja} key={loja.idParceiro} remover={() => voltarParceiroExistente(loja, i)} />
                                                                    )
                                                                }) :
                                                                (
                                                                    <div>
                                                                        Nenhum parceiro nesta lista
                                                                    </div>
                                                                )
                                                        }
                                                    </div>
                                                </>
                                            )
                                        }
                                    </>
                                )
                            }
                        </div>
                    </div>
                </div>
                {
                    permiteAdicionarAlterarResponsavel ? (
                        <div className={styles.blueBackground}>
                            <div className={styles.content}>
                                <AcoesUser status={status}
                                    key={user.userId}
                                    encerrar={encerrar}
                                    enviar={enviar}
                                    msgDialog={'Deseja cancelar esta ação? Todos os dados não salvos serão perdidos.'}
                                    redirect={'/responsaveis'}
                                    claimName={'Responsaveis'}
                                />
                            </div>
                        </div>
                    ) : null
                }

            </div>
            <ModalLoading
                open={modalLoading}
                size="lg"
            />

        </>
    );
}

export default Detalhes;